/**
 * SPA entrypoint. Mounts the QueryClientProvider + AuthProvider (which fetches
 * /api/me) around the router. Package design tokens + component styles are
 * imported once here, then portal-specific layout on top.
 */
import '@evt/flow-stream-ui/styles/tokens.css'
import '@evt/flow-stream-ui/styles/components.css'
import './styles/portal.css'

import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { AuthProvider } from './auth/AuthProvider'
import { queryClient } from './hooks/queryClient'
import { I18nProvider } from './i18n'
import { router } from './router'

const el = document.getElementById('root')
if (el) {
  createRoot(el).render(
    <StrictMode>
      <I18nProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </QueryClientProvider>
      </I18nProvider>
    </StrictMode>
  )
}
